<template>
  <v-autocomplete
    v-model="selectedTipos"
    label="Tipos"
    :items="arrayTipos"
    :dark="dark"
    :multiple="multiple"
    :rules="validate ? [rules.required] : ''"
    @change="onChanged()"
  >
    <template v-if="multiple" v-slot:prepend-item>
      <v-btn color="blue darken-2" text depressed @click="selectAll()">Marcar Todos</v-btn>&nbsp;
      <v-btn color="blue darken-2" text depressed @click="selectAll(false)">Desmarcar Todos</v-btn>

      <v-divider class="mt-2 mb-2"></v-divider>
    </template>

    <template v-slot:selection="{ item, index }">
      <v-chip v-if="index === 0">
        <span>{{ item }}</span>
      </v-chip>
      <span v-if="index === 1" class="red--text caption">(+{{ selectedTipos.length - 1 }})</span>
    </template>
  </v-autocomplete>
</template>

<script>
import rules from "@/utils/rules";

export default {
  name: "SelectTipo",

  props: {
    multiple: {
      type: Boolean,
      default: false
    },

    dark: {
      type: Boolean,
      default: false
    },

    validate: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      arrayTipos: [
        "Financiamento",
        "Financiamento Produto Forca",
        "Consorcio",
        "Veiculos",
        "Produto Forca",
        "Empresas",
        "Parametro Financiamento",
        "Parametro Financiamento Produto Forca",
        "Parametro Consorcio",
        "Parametro Comissão",
        "Parametro Leads"
      ],
      selectedTipos: [],
      rules
    };
  },

  methods: {
    selectAll(all = true) {
      if (all) {
        this.selectedTipos = this.arrayTipos;
      } else {
        this.selectedTipos = [];
      }

      this.onChanged();
    },

    onChanged() {
      this.$emit("onChanged", this.selectedTipos);
    }
  }
};
</script>
